import type {ServerDetectionResponse} from '../types';

const RECONNECT_BASE_DELAY_MS = 1000;
const MAX_RECONNECT_DELAY_MS = 10000;

export function getReconnectDelay(
  attempt: number,
  baseDelayMs = RECONNECT_BASE_DELAY_MS,
  maxDelayMs = MAX_RECONNECT_DELAY_MS,
) {
  return Math.min(baseDelayMs * 2 ** (attempt - 1), maxDelayMs);
}

export function parseDetectionResponse(data: string): ServerDetectionResponse | null {
  try {
    return JSON.parse(data) as ServerDetectionResponse;
  } catch (err) {
    console.error('Error processing WebSocket message:', err);
    return null;
  }
}
